import React from "react";
import SearchIcon from "../../../assets/svg/search-icon";
import { SearchInputProps } from "../types";

const SearchInput: React.FC<SearchInputProps> = ({
  searchQuery,
  searchPlaceholder,
  searchInputRef,
  onSearchQueryChange,
  showSearch,
  onKeyDown,
  className,
  searchIconClassName,
}) => {
  if (!showSearch) return null;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (
      ["ArrowDown", "ArrowUp", "Enter", "Escape", "Home", "End"].includes(
        event.key
      )
    ) {
      event.preventDefault();
      onKeyDown?.(event);
    }
  };

  return (
    <div
      className={`px-[12px] py-[10px] flex items-center gap-1 bg-pure-white dark:bg-pure-white-dk border-b border-border-gray dark:border-border-gray-dk ${className}`}
    >
      <SearchIcon
        className={`text-heading-text dark:text-heading-text-dk w-[14px] h-[14px] ${searchIconClassName}`}
      />
      <input
        ref={searchInputRef}
        type="text"
        placeholder={searchPlaceholder}
        value={searchQuery}
        onChange={(e) => onSearchQueryChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className="w-full text-sm bg-transparent border-none outline-none text-heading-text dark:text-heading-text-dk placeholder:text-gray-placeholder dark:placeholder:text-gray-placeholder-dk"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default SearchInput;
